/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

import LoadingIcon from 'bundles/xddp/components/shared/LoadingIcon';

const styles: Record<string, Interpolation<Theme>> = {
  loadingSpinner: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

const EoiLoading = () => {
  return (
    <div id="eoi">
      <div css={styles.loadingSpinner}>
        <LoadingIcon size="large" color="interactive" />
      </div>
    </div>
  );
};

export default EoiLoading;
